import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Col, Form, FormGroup, Row, Grid } from "react-bootstrap";
import { dropdown } from "../../../../utils/forms/validators";

import { EDIT_EMPLOYER_EMAIL_PREFERENCES } from "../../../../actions/user.actions";

import Button from "../../../../components/common/button/Button";
import Select2 from "../../../../components/common/select/Select2";
import styles from "./EmailPreferences.scss";

const dropdownValidation = dropdown("Please select an option.");

class EmailPreferences extends Component {
  renderOptions(options, types) {
    const preferences = types.map(type => (
      <Row key={type.slug} className={styles.row}>
        <Col xs={12} sm={6} className={styles.rowLeft}>
          {type.value}
        </Col>
        <Col xs={12} sm={6} className={styles.rowRight}>
          <Field
            name={type.slug}
            type="select"
            placeholder="Options"
            component={Select2}
            options={options}
            validate={dropdownValidation}
          />
        </Col>
      </Row>
    ));

    return preferences;
  }

  render() {
    const { handleSubmit, submitting, valid, options, types } = this.props;

    return (
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>Email Preferences</h2>

          <Form onSubmit={handleSubmit}>
            <Grid className={styles.form}>
              <FormGroup className={styles.formGroup}>
                {this.renderOptions(options, types)}
              </FormGroup>

              <Button
                isPrimary
                type="submit"
                size={"large"}
                label="Save Changes"
                isDisabled={!valid || submitting}
              />
            </Grid>
          </Form>
        </div>
      </section>
    );
  }
}

EmailPreferences = reduxForm({
  form: EDIT_EMPLOYER_EMAIL_PREFERENCES,
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(EmailPreferences);

EmailPreferences = connect((props, state) => {
  const user = state.user;
  const types = state.types;

  let initialValues = {};
  if (types.length > 0) {
    types.forEach(function(type) {
      const email_preferences = _.get(user, "email_preferences");

      if (email_preferences) {
        const option = email_preferences.filter(
          option => option.type_id && option.type_id === type.id
        );

        if (option) {
          const value = { [`${type.slug}`]: _.first(option).option_id };
          initialValues = { ...initialValues, ...value };
        }
      }
    });
  }

  return {
    initialValues
  };
})(EmailPreferences);

export default EmailPreferences;



// WEBPACK FOOTER //
// ./src/routes/employer/emailPreferences/components/EmailPreferences.js